import { render, staticRenderFns } from "./borrowTabsPage.vue?vue&type=template&id=68cb37b8&scoped=true&"
import script from "./borrowTabsPage.vue?vue&type=script&lang=js&"
export * from "./borrowTabsPage.vue?vue&type=script&lang=js&"
import style0 from "./borrowTabsPage.vue?vue&type=style&index=0&id=68cb37b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cb37b8",
  null
  
)

export default component.exports